import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import authReducer from './slices/authSlice'; // Make sure the path is correct
import cartReducer from './slices/cartSlice'; // If you have a cart slice, import it

const appReducer = combineReducers({
  authReducer,
  cartReducer,
  // Add other reducers here if you have them
});

// Clean geral no logout: ao receber `auth/logout`, descarta todo o state e deixa
// cada slice voltar ao seu initialState. O authReducer ainda processa a própria
// ação (limpa token do localStorage). Cobre logout manual e expiração de sessão.
const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    state = undefined;
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: 'root', // The key for the localStorage item
  version: 1,
  storage, // Use localStorage
  // whitelist: ['auth'], // Only 'auth' slice will be persisted. Remove this line to persist all reducers.
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these Redux-persist actions to prevent console warnings
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

// You can export both or just store, depending on your needs
export default store;